(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1492],{

/***/ 88758:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[rootKey]/partnerships",
      function () {
        return __webpack_require__(7597);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_B": function() { return /* binding */ LiquidDamage; },
/* harmony export */   "iF": function() { return /* binding */ OrderStatus; },
/* harmony export */   "ki": function() { return /* binding */ ElectronicsFailure; },
/* harmony export */   "qI": function() { return /* binding */ ScreenDamage; },
/* harmony export */   "s7": function() { return /* binding */ AccidentalDamage; }
/* harmony export */ });
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["PAYMENT_SUCCESS_BY_CUSTOMER"] = "PAYMENT_SUCCESS_BY_CUSTOMER";
    OrderStatus["PAYMENT_SUCCESS_BY_DEALER"] = "PAYMENT_SUCCESS_BY_DEALER";
    OrderStatus["POLICY_CREATED"] = "POLICY_CREATED";
})(OrderStatus || (OrderStatus = {}));
var LiquidDamage = {
    icon: "/icons/mpos/liquidDamage.svg",
    title: "Liquid damage",
    subTitle: "Coffee spills? No problem, we'll fix that"
};
var AccidentalDamage = {
    icon: "/icons/mpos/accidentalDamage.svg",
    title: "Accidental Damage",
    subTitle: "Dropped your device? We'll fix that too!"
};
var ScreenDamage = {
    icon: "/icons/mpos/liquidDamage.svg",
    title: "Screen damage",
    subTitle: "Cracked your screen? We’ll replace it!"
};
var ElectronicsFailure = {
    icon: "/icons/mpos/electronics.svg",
    title: "Electrical & mechanical failures",
    subTitle: "Device stopped working? We’ll fix it!"
};


/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(96856)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(11720));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(11720));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(11720));
var _loadableContext = __webpack_require__(16319);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(61688)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 7597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _rootKey_partnerships; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./utils/styles/index.ts
var styles = __webpack_require__(17631);
// EXTERNAL MODULE: ./utils/responsive/index.tsx
var responsive = __webpack_require__(41798);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.common/dist/index.js
var dist = __webpack_require__(79749);
;// CONCATENATED MODULE: ./components/partnerships/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LandingPageWrapper = dist.styled.div(_templateObject());

// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
;// CONCATENATED MODULE: ./components/partnerships/header/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: #5e27c9;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 1440px;\n    margin: auto;\n    padding: 0 120px;\n\n    @media only screen and (max-width: 780px) {\n        padding: 0 20px;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    width: 189px;\n    padding: 16px 32px;\n    background: #37c87e;\n    border-radius: 8px;\n    color: #ffffff;\n    margin-top: 42px;\n    justify-content: center;\n    cursor: pointer;\n    width: 250px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n\n    @media only screen and (max-width: 1320px) {\n        justify-content: center;\n        text-align: center;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n\n    @media only screen and (max-width: 1320px) {\n        order: 2;\n        align-items: center;\n        margin: 20px 0 40px 0;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-family: Inter;\n    font-style: normal;\n    font-weight: bold;\n    font-size: 42px;\n    line-height: 52px;\n    letter-spacing: -0.4px;\n    color: #ffffff;\n    max-width: 500px;\n\n    @media only screen and (max-width: 780px) {\n        font-size: 24px;\n        line-height: 34px;\n        text-align: center;\n        letter-spacing: unset;\n        max-width: 600px;\n        margin: 0 40px;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-right: 40px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var HeaderWrapper = dist.styled.div(styles_templateObject());
var Container = dist.styled.div(_templateObject1());
var RequestDemoButton = dist.styled.div(_templateObject2());
var LogoWrapper = dist.styled.div(_templateObject3());
var ContentWrapper = dist.styled.div(_templateObject4());
var TextWrapper = dist.styled.div(_templateObject5());
var TitleText = dist.styled.div(_templateObject6());
var BannerWrapper = dist.styled.div(_templateObject7());

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/generics/index.ts
var generics = __webpack_require__(3949);
// EXTERNAL MODULE: ./utils/constants/index.ts
var constants = __webpack_require__(61485);
;// CONCATENATED MODULE: ./components/partnerships/header/index.tsx







var RequestDemoModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8520).then(__webpack_require__.bind(__webpack_require__, 28520));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28520)
            ];
        }
    }
});
var Header = function(param) {
    var isMobile = param.isMobile;
    var ref = (0,compat_module.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var onClick = function() {
        window.location.href = "/";
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(HeaderWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(LogoWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        width: !isMobile ? "82px" : "63px",
                        height: !isMobile ? "26px" : "20px",
                        onClick: onClick,
                        src: constants/* AckoLogoConfig.light */.G4.light
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TextWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(TitleText, {
                                    children: "Get smart insurance solutions tailor-made for your business"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(RequestDemoButton, {
                                    onClick: setIsModalOpen,
                                    children: "Request Demo"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(BannerWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                src: (0,generics/* getImageBasePath */.m4)("/images/partnershipHeader.svg"),
                                width: !isMobile ? "533px" : "700px",
                                height: !isMobile ? "400px" : "526px"
                            })
                        })
                    ]
                }),
                isModalOpen && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(RequestDemoModal, {
                    popupStatus: isModalOpen,
                    onClose: setIsModalOpen
                })
            ]
        })
    });
};
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./components/partnerships/whyAcko/styles.ts

function whyAcko_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 60px 140px;\n    max-width: 1440px;\n    margin: auto;\n    @media screen and (max-width: 780px) {\n        padding: 40px 20px;\n    }\n"
    ]);
    whyAcko_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 30px;\n    line-height: 36px;\n    text-align: center;\n    color: #434f5a;\n    @media screen and (min-width: 780px) {\n        margin-bottom: 50px;\n    }\n    @media screen and (max-width: 780px) {\n        font-size: 26px;\n        line-height: 31px;\n        letter-spacing: 0.02em;\n        margin-bottom: 10px;\n    }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n\n    @media screen and (max-width: 780px) {\n        display: flex;\n        flex-direction: column;\n    }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    margin: 0 20px;\n    @media screen and (max-width: 780px) {\n        margin: 20px 0;\n    }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 115px;\n    @media screen and (max-width: 780px) {\n        width: 86px;\n    }\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 18px;\n    line-height: 24px;\n    text-align: center;\n    letter-spacing: 0.02em;\n    color: #282e33;\n    margin-top: 18px;\n    @media screen and (max-width: 780px) {\n        margin-top: 17px;\n    }\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 20px;\n    text-align: center;\n    letter-spacing: 0.02em;\n    color: #434f5a;\n    margin-top: 16px;\n\n    @media screen and (max-width: 780px) {\n        margin: 0 20px;\n    }\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var WhyAckoWrapper = dist.styled.div(whyAcko_styles_templateObject());
var Title = dist.styled.div(styles_templateObject1());
var OptionsWrapper = dist.styled.div(styles_templateObject2());
var Option = dist.styled.div(styles_templateObject3());
var Image = dist.styled.img(styles_templateObject4());
var OptionHeading = dist.styled.div(styles_templateObject5());
var OptionSubHeading = dist.styled.div(styles_templateObject6());

;// CONCATENATED MODULE: ./components/partnerships/whyAcko/index.tsx




var options = [
    {
        image: "/images/launch.svg",
        heading: "Effortless Launch",
        subHeading: "Launch insurance in a day with our quick and easy-to-integrate RESTful APIs."
    },
    {
        image: "/images/plan.svg",
        heading: "Tailor-made Plans",
        subHeading: "Get insurance solutions that are customised to meet your business needs."
    },
    {
        image: "/images/experience.svg",
        heading: "Great Customer Experience",
        subHeading: "Upgrade customer experience with quick claim settlement & easy paperless process."
    }, 
];
var WhyAckoOption = function(props) {
    var image = props.image, heading = props.heading, subHeading = props.subHeading, isMobile = props.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(Option, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                src: (0,generics/* getImageBasePath */.m4)(image),
                height: isMobile ? "86px" : "115px",
                width: isMobile ? "86px" : "115px"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OptionHeading, {
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OptionSubHeading, {
                children: subHeading
            })
        ]
    });
};
var WhyAcko = function(param) {
    var isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(WhyAckoWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Title, {
                children: "Why Acko"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(OptionsWrapper, {
                children: options === null || options === void 0 ? void 0 : options.map(function(option, i) {
                    var image = option.image, heading = option.heading, subHeading = option.subHeading;
                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(WhyAckoOption, {
                        image: image,
                        heading: heading,
                        subHeading: subHeading,
                        isMobile: isMobile
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var whyAcko = (WhyAcko);

;// CONCATENATED MODULE: ./components/partnerships/partners/styles.ts

function partners_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: #f1f3f8;\n"
    ]);
    partners_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function partners_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 60px 140px;\n    max-width: 1440px;\n    margin: auto;\n    @media screen and (max-width: 780px) {\n        padding: 40px 20px;\n    }\n"
    ]);
    partners_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function partners_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 30px;\n    line-height: 36px;\n    text-align: center;\n    color: #434f5a;\n    margin-bottom: 40px;\n\n    @media screen and (max-width: 780px) {\n        font-size: 26px;\n        line-height: 31px;\n        letter-spacing: 0.02em;\n    }\n"
    ]);
    partners_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function partners_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    row-gap: 40px;\n    column-gap: 120px;\n    flex-wrap: wrap;\n    margin: 0 80px;\n    margin-top: 70px;\n    margin-bottom: 20px;\n\n    @media screen and (max-width: 780px) {\n        column-gap: 100px;\n        margin: 0 100px;\n    }\n\n    @media screen and (max-width: 480px) {\n        column-gap: 40px;\n        margin: 0 20px;\n    }\n"
    ]);
    partners_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function partners_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-self: center;\n    padding: 20px;\n"
    ]);
    partners_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Wrapper = dist.styled.div(partners_styles_templateObject());
var PartnerWrapper = dist.styled.div(partners_styles_templateObject1());
var PartnerTitle = dist.styled.div(partners_styles_templateObject2());
var PartnersContainer = dist.styled.div(partners_styles_templateObject3());
var PartnerDiv = dist.styled.div(partners_styles_templateObject4());

;// CONCATENATED MODULE: ./components/partnerships/partners/index.tsx




var partnerBrands = [
    {
        name: "Amazon",
        path: "/images/partners/amazon.svg"
    },
    {
        name: "Hdfc",
        path: "/images/partners/hdfc.svg"
    },
    {
        name: "Ola",
        path: "/images/partners/ola.svg"
    },
    {
        name: "Swiggy",
        path: "/images/partners/swiggy.svg"
    },
    {
        name: "Cred",
        path: "/images/partners/cred.svg"
    },
    {
        name: "MoneyTap",
        path: "/images/partners/moneytap.svg"
    },
    {
        name: "Goibibo",
        path: "/images/partners/goibibo.svg"
    },
    {
        name: "Zomato",
        path: "/images/partners/zomato.svg"
    }, 
];
var Partners = function(param) {
    var isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(PartnerWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PartnerTitle, {
                    children: "Our Partners"
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PartnersContainer, {
                    children: partnerBrands === null || partnerBrands === void 0 ? void 0 : partnerBrands.map(function(partner) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                src: (0,generics/* getImageBasePath */.m4)(partner === null || partner === void 0 ? void 0 : partner.path),
                                width: isMobile ? "70px" : "130px",
                                height: isMobile ? "24px" : "42px",
                                alt: partner === null || partner === void 0 ? void 0 : partner.name
                            })
                        }, partner === null || partner === void 0 ? void 0 : partner.name);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var partners = (Partners);

;// CONCATENATED MODULE: ./components/partnerships/testimonials/styles.ts

function testimonials_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: #e4eaf1;\n"
    ]);
    testimonials_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function testimonials_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 60px 140px;\n    max-width: 1440px;\n    margin: auto;\n\n    @media screen and (max-width: 1200px) {\n        padding: 60px;\n    }\n\n    @media screen and (max-width: 780px) {\n        padding: 40px 20px;\n    }\n"
    ]);
    testimonials_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function testimonials_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 30px;\n    line-height: 36px;\n    text-align: center;\n    color: #434f5a;\n    @media screen and (max-width: 780px) {\n        letter-spacing: 0.02em;\n        font-size: 26px;\n        line-height: 31px;\n    }\n"
    ]);
    testimonials_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function testimonials_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: row;\n    margin-top: 120px;\n    @media screen and (max-width: 780px) {\n        margin-top: 0;\n        flex-direction: column;\n    }\n"
    ]);
    testimonials_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function testimonials_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    background: #ffffff;\n    border-radius: 10px;\n    padding: 20px;\n    margin: 0 25px;\n    @media screen and (max-width: 780px) {\n        margin: 0;\n        margin-top: 90px;\n    }\n"
    ]);
    testimonials_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function testimonials_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    background: #ffffff;\n    border-radius: 10px;\n    padding: 20px;\n    margin: 0 25px;\n    padding-bottom: 20px;\n    margin: 0;\n"
    ]);
    testimonials_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function testimonials_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    margin-top: -90px;\n    @media screen and (max-width: 780px) {\n        margin-top: -70px;\n    }\n"
    ]);
    testimonials_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 131px;\n    @media screen and (max-width: 780px) {\n        width: 100px;\n    }\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 28px;\n    color: #0b0e34;\n    @media screen and (max-width: 780px) {\n        font-size: 18px;\n        line-height: 28px;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 15px;\n    align-items: center;\n    letter-spacing: 0.5px;\n    color: #5d607c;\n    margin-top: 4px;\n    @media screen and (max-width: 780px) {\n        font-size: 12px;\n        line-height: 15px;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    margin-top: 16px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 20px;\n    align-items: center;\n    text-align: center;\n    color: #8788a0;\n    margin-top: 24px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}

var styles_Wrapper = dist.styled.div(testimonials_styles_templateObject());
var TestimonialsWrapper = dist.styled.div(testimonials_styles_templateObject1());
var styles_Title = dist.styled.div(testimonials_styles_templateObject2());
var CardContainer = dist.styled.div(testimonials_styles_templateObject3());
var CardWrapper = dist.styled.div(testimonials_styles_templateObject4());
var CardContentWrapper = dist.styled.div(testimonials_styles_templateObject5());
var ImageContainer = dist.styled.div(testimonials_styles_templateObject6());
var styles_Image = dist.styled.img(styles_templateObject7());
var Name = dist.styled.div(_templateObject8());
var Position = dist.styled.div(_templateObject9());
var Rating = dist.styled.div(_templateObject10());
var Review = dist.styled.div(_templateObject11());

;// CONCATENATED MODULE: ./components/partnerships/testimonials/card/index.tsx




var Card = function(props) {
    var avatar = props.avatar, name = props.name, position = props.position, review = props.review;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    src: (0,generics/* getImageBasePath */.m4)(avatar),
                    height: "130px",
                    width: "130px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(CardContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Name, {
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Position, {
                        children: position
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Rating, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            height: "18px",
                            width: "104px",
                            src: (0,generics/* getImageBasePath */.m4)("/images/rating.svg")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Review, {
                        children: review
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var card = (Card);

;// CONCATENATED MODULE: ./components/partnerships/testimonials/index.tsx



var profiles = [
    {
        avatar: "/images/testimonials/sumeet.svg",
        name: "Sumeet Choudhary",
        position: "Director, Lendingkart",
        review: "“ACKO has done an excellent job in capturing our vision of delivering outstanding value to our customers. The principle of making insurance simple and comprehensible with their online process has struck a chord with our customer base. This has made a significant business impact.”"
    },
    {
        avatar: "/images/testimonials/rikant.svg",
        name: "Rikant Pitti",
        position: "Co-founder, EaseMytrip.com",
        review: "“Working with ACKO, as our trusted partner has been a pleasure. While we are committed to providing our customers with the best experience on their travel, ACKO’s digital insurance further substantiates our core values. A seamless experience when it comes to travel or even while making a claim.”"
    },
    {
        avatar: "/images/testimonials/anuj.svg",
        name: "Anuj Kacker",
        position: "Co-founder, MoneyTap",
        review: "“When providing financial help to our customers, we wanted to collaborate with a partner who would give us an edge and help us achieve long-term success. Enhancing the customer experience was our priority and ACKO was an unequivocal choice for their diverse offerings. We are happy to say that ACKO has been a true technology partner. Looking to cross many milestones together”"
    }, 
];
var Testimonials = function() {
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(TestimonialsWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Title, {
                    children: "Testimonials"
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(CardContainer, {
                    children: profiles === null || profiles === void 0 ? void 0 : profiles.map(function(profile) {
                        var avatar = profile.avatar, name = profile.name, position = profile.position, review = profile.review;
                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(card, {
                            avatar: avatar,
                            name: name,
                            position: position,
                            review: review
                        }, name);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var testimonials = (Testimonials);

;// CONCATENATED MODULE: ./components/partnerships/claimExperience/styles.ts

function claimExperience_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    max-width: 1440px;\n    margin: auto;\n"
    ]);
    claimExperience_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function claimExperience_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    width: 100%;\n\n    @media screen and (max-width: 1400px) {\n        align-items: center;\n        justify-content: center;\n    }\n\n    @media screen and (max-width: 780px) {\n        margin-bottom: -200px;\n    }\n\n    @media screen and (max-width: 400px) {\n        margin-bottom: -140px;\n    }\n"
    ]);
    claimExperience_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function claimExperience_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 40px;\n    margin-top: 80px;\n    margin-left: 140px;\n    @media screen and (max-width: 780px) {\n        margin: 0;\n        padding: 20px;\n    }\n"
    ]);
    claimExperience_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function claimExperience_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    @media screen and (max-width: 780px) {\n        position: relative;\n        top: -220px;\n    }\n\n    @media screen and (max-width: 400px) {\n        position: relative;\n        top: -160px;\n    }\n"
    ]);
    claimExperience_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function claimExperience_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: bold;\n    font-size: 30px;\n    line-height: 36px;\n    color: #414a53;\n    margin-bottom: 12px;\n    @media screen and (max-width: 780px) {\n        justify-content: center;\n        margin-top: 20px;\n        padding: 0 40px;\n        text-align: center;\n        font-size: 26px;\n        letter-spacing: 0.02em;\n        line-height: 31px;\n    }\n"
    ]);
    claimExperience_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function claimExperience_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    margin-top: 24px;\n"
    ]);
    claimExperience_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function claimExperience_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n"
    ]);
    claimExperience_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function claimExperience_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: normal;\n    font-size: 16px;\n    line-height: 24px;\n    align-items: center;\n    color: #5d607c;\n    margin-left: 21px;\n"
    ]);
    claimExperience_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

var claimExperience_styles_Wrapper = dist.styled.div(claimExperience_styles_templateObject());
var ClaimExperienceContainer = dist.styled.div(claimExperience_styles_templateObject1());
var ExperienceItem = dist.styled.div(claimExperience_styles_templateObject2());
var ImageItem = dist.styled.div(claimExperience_styles_templateObject3());
var claimExperience_styles_Title = dist.styled.div(claimExperience_styles_templateObject4());
var ClaimItemWrapper = dist.styled.div(claimExperience_styles_templateObject5());
var ClaimItemIconWrapper = dist.styled.div(claimExperience_styles_templateObject6());
var ClaimItemText = dist.styled.div(claimExperience_styles_templateObject7());

;// CONCATENATED MODULE: ./components/partnerships/claimExperience/index.tsx




var claimItems = [
    "All-digital process for a hassle-free experience",
    "3-step claim procedure for a smooth customer journey",
    "Real-time tracking to stay updated and manage claim status",
    "Exceptional turnaround time of 3-5 working days", 
];
var ClaimItem = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ClaimItemWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ClaimItemIconWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    src: (0,generics/* getImageBasePath */.m4)("/icons/listBullet.svg"),
                    height: "24px",
                    width: "24px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ClaimItemText, {
                children: text
            })
        ]
    });
};
var ClaimExperience = function(param) {
    var isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(claimExperience_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ClaimExperienceContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ExperienceItem, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(claimExperience_styles_Title, {
                            children: "Claim Experience with ACKO"
                        }),
                        claimItems.map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ClaimItem, {
                                text: item
                            }, i);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ImageItem, {
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: (0,generics/* getImageBasePath */.m4)(isMobile ? "/images/mobileClaimExperience.svg" : "/images/claimExperience.svg"),
                        height: isMobile ? "1000px" : "510px",
                        width: isMobile ? "540px" : "720px"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var claimExperience = (ClaimExperience);

;// CONCATENATED MODULE: ./components/partnerships/products/styles.ts

function products_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 1160px;\n    margin: auto;\n"
    ]);
    products_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function products_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 20px 30px;\n    background-color: #ffffff;\n    max-width: 465px;\n    height: 350px;\n    // Setting order for moving card to right side\n    order: ",
        ";\n\n    @media screen and (max-width: 1200px) {\n        order: 2;\n        max-width: unset;\n        height: unset;\n        margin-bottom: 20px;\n    }\n"
    ]);
    products_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function products_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: bold;\n    font-size: 22px;\n    line-height: 32px;\n    color: #0b0e34;\n    padding-top: 20px;\n    @media screen and (max-width: 780px) {\n        padding-top: 0;\n        font-size: 16px;\n    }\n"
    ]);
    products_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function products_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 22px;\n    color: #5d607c;\n    margin-top: 20px;\n    @media screen and (max-width: 780px) {\n        font-size: 13px;\n        margin-top: 5px;\n    }\n"
    ]);
    products_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function products_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 12px;\n    padding-bottom: 20px;\n"
    ]);
    products_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function products_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 22px;\n    color: #5d607c;\n    margin-left: 5px;\n    @media screen and (max-width: 780px) {\n        font-size: 13px;\n    }\n"
    ]);
    products_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function products_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 800;\n    font-size: 26px;\n    line-height: 31px;\n    text-align: center;\n    letter-spacing: 0.02em;\n    color: #414a53;\n    @media screen and (max-width: 780px) {\n        margin-top: 32px;\n        margin-bottom: 20px;\n        font-size: 26px;\n    }\n"
    ]);
    products_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function products_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 60px 140px;\n    background-color: #f1f3f8;\n    @media screen and (max-width: 780px) {\n        padding: 40px 20px;\n    }\n"
    ]);
    products_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-top: 60px;\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var styles_Container = dist.styled.div(products_styles_templateObject());
var styles_CardContainer = dist.styled.div(products_styles_templateObject1(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.order) === 2 ? 2 : "";
});
var products_styles_Title = dist.styled.div(products_styles_templateObject2());
var Description = dist.styled.div(products_styles_templateObject3());
var PointsWrapper = dist.styled.div(products_styles_templateObject4());
var Points = dist.styled.li(products_styles_templateObject5());
var Heading = dist.styled.div(products_styles_templateObject6());
var products_styles_Wrapper = dist.styled.div(products_styles_templateObject7());
var ProductsWrapper = dist.styled.div(styles_templateObject8());
var ProductDetails = dist.styled.div(styles_templateObject9());

;// CONCATENATED MODULE: ./components/partnerships/products/card/index.tsx


var card_Card = function(props) {
    var title = props.title, description = props.description, points = props.points, order = props.order;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_CardContainer, {
        order: order,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(products_styles_Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Description, {
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(PointsWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("ul", {
                    style: {
                        margin: "unset",
                        marginLeft: "20px",
                        padding: "unset"
                    },
                    children: points.map(function(point, i) {
                        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Points, {
                            children: point
                        }, i);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var products_card = (card_Card);

;// CONCATENATED MODULE: ./components/partnerships/products/index.tsx






var products = [
    {
        title: "Credit Shield Insurance",
        description: "ACKO Credit Shield Insurance has enabled partners like Lendingkart, MoneyTap, ZestMoney, and HDB Financial Services to keep their customers protected. This has in turn increased customer satisfaction and promoted brand loyalty.",
        points: [
            "Provides financial security",
            "Protects loan portfolio if the customer meets with any unforeseen situations",
            "Extends fixed hospicash payment to the customer in case of hospitalisation", 
        ],
        image: "/images/shield.svg"
    },
    {
        title: "GIG Insurance",
        description: "The first-of-its-kind insurance plan, ACKO GIG Insurance helps companies such as Swiggy, Zomato, Rapido, etc. in protecting their ground fleet with tailor-made covers.",
        points: [
            "Insures employees for personal accidents, death, illness, etc, with customisable plans",
            "Covers employees on their active working days.",
            "Cost-effective and pay-per-use insurance covers for drivers and ground fleet.", 
        ],
        image: "/images/gigInsurance.svg"
    },
    {
        title: "Travel Insurance",
        description: "For partners like Goibibo, RedBus, EaseMyTrip, OLA, and OYO, the ACKO Travel Insurance has enhanced customer experience with innovative services such as paperless claim filing and instant settlement.",
        points: [
            "Covers the costs and losses associated with travelling.",
            "Cutting-edge covers to secure all kinds of travel plans: from cab & bus rides, to hotel and flight bookings",
            "The travel insurance products have a commendable NPS of +90", 
        ],
        image: "/images/travelInsurance.svg"
    }, 
];
var Products = function() {
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(products_styles_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Heading, {
                    children: "ACKO Products"
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ProductsWrapper, {
                    children: products === null || products === void 0 ? void 0 : products.map(function(product, i) {
                        var title = product.title, description = product.description, points = product.points, image = product.image;
                        return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(ProductDetails, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(products_card, {
                                    title: title,
                                    description: description,
                                    points: points,
                                    order: i % 2 === 0 ? 1 : 2
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    height: isMobile ? "555px" : "350px",
                                    width: isMobile ? "740px" : "465px",
                                    src: (0,generics/* getImageBasePath */.m4)(image),
                                    objectFit: "cover"
                                })
                            ]
                        }, title);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var partnerships_products = (Products);

;// CONCATENATED MODULE: ./components/partnerships/footer/styles.ts

function footer_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 40px;\n    background: #343758;\n    @media screen and (max-width: 780px) {\n        padding: 32px 20px;\n    }\n"
    ]);
    footer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function footer_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    border: 1px solid #5bdb89;\n    box-sizing: border-box;\n    border-radius: 8px;\n    color: #5bdb89;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 18px;\n    cursor: pointer;\n    padding: 12px;\n    margin-top: 24px;\n    @media screen and (min-width: 780px) {\n        padding: 16px 0;\n        width: 190px;\n    }\n"
    ]);
    footer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function footer_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: 800;\n    font-size: 26px;\n    line-height: 31px;\n    text-align: center;\n    letter-spacing: 0.02em;\n    color: #ffffff;\n    @media screen and (max-width: 780px) {\n        font-size: 26px;\n        letter-spacing: 0.02em;\n        justify-content: flex-start;\n    }\n"
    ]);
    footer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function footer_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 15px;\n    color: #8a99a9;\n    margin-top: 11px;\n    @media screen and (max-width: 780px) {\n        font-size: 12px;\n        letter-spacing: 0.02em;\n        margin-top: 8px;\n        justify-content: flex-start;\n    }\n"
    ]);
    footer_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function footer_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    @media screen and (max-width: 780px) {\n        justify-content: flex-start;\n    }\n"
    ]);
    footer_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var footer_styles_Wrapper = dist.styled.div(footer_styles_templateObject());
var styles_RequestDemoButton = dist.styled.div(footer_styles_templateObject1());
var styles_Heading = dist.styled.div(footer_styles_templateObject2());
var SubHeading = dist.styled.div(footer_styles_templateObject3());
var RequestDemoButtonWrapper = dist.styled.div(footer_styles_templateObject4());

;// CONCATENATED MODULE: ./components/partnerships/footer/index.tsx




var footer_RequestDemoModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8520).then(__webpack_require__.bind(__webpack_require__, 28520));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28520)
            ];
        }
    }
});
var Footer = function() {
    var ref = (0,compat_module.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(footer_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_Heading, {
                children: "Ready to get started?"
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SubHeading, {
                children: "Whether you’re just getting started with insurance or are looking to enhance existing offerings, ACKO has opportunities for you to get to market rapidly and effectively."
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(RequestDemoButtonWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles_RequestDemoButton, {
                    onClick: function() {
                        return setIsModalOpen(true);
                    },
                    children: "Request a demo"
                })
            }),
            isModalOpen && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(footer_RequestDemoModal, {
                popupStatus: isModalOpen,
                onClose: setIsModalOpen
            })
        ]
    });
};
/* harmony default export */ var footer = (Footer);

;// CONCATENATED MODULE: ./components/partnerships/index.tsx




// Components







var PartnershipsLandingMain = function() {
    var isMobile = (0,responsive/* useViewport */.S)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* GlobalStyle */.wr, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(LandingPageWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(header, {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(whyAcko, {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(partners, {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(testimonials, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(claimExperience, {
                        isMobile: isMobile
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(partnerships_products, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(footer, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var partnerships = (PartnershipsLandingMain);

;// CONCATENATED MODULE: ./pages/[rootKey]/partnerships/index.tsx


var PartnershipsLandingPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(partnerships, {});
};
/* harmony default export */ var _rootKey_partnerships = (PartnershipsLandingPage);


/***/ }),

/***/ 3949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DX": function() { return /* binding */ getTitleCase; },
/* harmony export */   "El": function() { return /* binding */ getCoverage; },
/* harmony export */   "Oq": function() { return /* binding */ clearFnolCacheAndRedirectToElectronicsPdp; },
/* harmony export */   "cD": function() { return /* binding */ useProjectAllInSource; },
/* harmony export */   "gg": function() { return /* binding */ deleteCachedData; },
/* harmony export */   "jE": function() { return /* binding */ isAmazonRedirection; },
/* harmony export */   "m4": function() { return /* binding */ getImageBasePath; },
/* harmony export */   "oX": function() { return /* binding */ whatsCoverText; }
/* harmony export */ });
/* unused harmony exports getTncLink, getElectronicsPdpUrl */
/* harmony import */ var _components_mpos_partner_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91137);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61485);


var getImageBasePath = function(imagePath) {
    var imageStaticPath =  true ? "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets".split("/next_assets")[0] : 0;
    var basePath = imageStaticPath ? "".concat(imageStaticPath, "/_next_static") : "/_next_static";
    if (basePath === "/_next_static") {
        return imagePath;
    }
    return "".concat(basePath).concat(imagePath);
};
var getTncLink = function() {
    try {
        var staticPath =  true ? "https://partnership-frontend-nextjs-prod.ackoassets.com/next_assets".split("/next_assets")[0] : 0;
        return "".concat(staticPath, "/_next_static/static/mpos_customer_tnc.html");
    } catch (e) {
        return "/_next_static/static/mpos_customer_tnc.html";
    }
};
var getCoverage = function(plan) {
    try {
        if (plan.includes("Screen Damage")) {
            return [
                _components_mpos_partner_constants__WEBPACK_IMPORTED_MODULE_0__/* .ScreenDamage */ .qI
            ];
        }
        if (plan.includes("Comprehensive")) {
            return [
                _components_mpos_partner_constants__WEBPACK_IMPORTED_MODULE_0__/* .LiquidDamage */ ._B,
                _components_mpos_partner_constants__WEBPACK_IMPORTED_MODULE_0__/* .AccidentalDamage */ .s7
            ];
        }
        if (plan.includes("Extended Warranty")) {
            return [
                _components_mpos_partner_constants__WEBPACK_IMPORTED_MODULE_0__/* .ElectronicsFailure */ .ki
            ];
        }
        return [];
    } catch (e) {
        return [];
    }
};
var whatsCoverText = function(plan) {
    try {
        if (plan === null || plan === void 0 ? void 0 : plan.includes("screen damage")) {
            return "Screen damage";
        }
        if (plan === null || plan === void 0 ? void 0 : plan.includes("comprehensive")) {
            return "Screen damage with liquid damage";
        }
        if ((plan === null || plan === void 0 ? void 0 : plan.includes("extended warranty")) || (plan === null || plan === void 0 ? void 0 : plan.includes("_ew"))) {
            return "Electronical & mechanical failures";
        }
        return "-";
    } catch (e) {
        return "-";
    }
};
var getTitleCase = function(str) {
    return str.toLowerCase().split(" ").map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(" ");
};
var useProjectAllInSource = function(router) {
    if (true) {
        var ref;
        var querySource = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.source) || (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .PROJECT_ALL_IN.SESSION_KEY */ .f3.SESSION_KEY)) || "";
        return querySource;
    }
    return "";
};
var isAmazonRedirection = function(policyId) {
    return (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("redirectionSource")) === "".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .AMAZON_REDIRECTION.QUERY_SOURCE */ .Wj.QUERY_SOURCE, "_").concat(policyId);
};
var deleteCachedData = function() {
    var policyId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var ref, ref1;
    if (false) {}
    var localPolicyId = policyId !== null && policyId !== void 0 ? policyId : (ref = new URL(window.location.href)) === null || ref === void 0 ? void 0 : (ref1 = ref.searchParams) === null || ref1 === void 0 ? void 0 : ref1.get("policyid");
    if (!localPolicyId) return;
    try {
        var cachedClaimNumbers = localStorage.getItem("generatedClaimNumber");
        var claimNumbers = cachedClaimNumbers && JSON.parse(cachedClaimNumbers);
        if (claimNumbers && typeof claimNumbers === "object") {
            delete claimNumbers[localPolicyId];
            localStorage.setItem("generatedClaimNumber", JSON.stringify(claimNumbers));
        }
        var cachedFnolData = localStorage.getItem("fnolData");
        var fnolData = cachedFnolData && JSON.parse(cachedFnolData);
        if (fnolData && typeof fnolData === "object") {
            delete fnolData[localPolicyId];
            localStorage.setItem("fnolData", JSON.stringify(fnolData));
        }
    } catch (e) {}
};
var getElectronicsPdpUrl = function(policyId) {
    return "/electronics/coi?id=".concat(encodeURIComponent(policyId));
};
var clearFnolCacheAndRedirectToElectronicsPdp = function(policyId) {
    if (!policyId || "object" === "undefined") {
        return;
    }
    deleteCachedData(policyId);
    setTimeout(function() {
        window.location.href = getElectronicsPdpUrl(policyId);
    }, 2000);
};


/***/ }),

/***/ 17631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bc": function() { return /* binding */ ErrorMessage; },
/* harmony export */   "Ei": function() { return /* binding */ Img; },
/* harmony export */   "Ts": function() { return /* binding */ ButtonLoaderImage; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "og": function() { return /* binding */ CenterDiv; },
/* harmony export */   "wY": function() { return /* binding */ PageLoader; },
/* harmony export */   "wr": function() { return /* binding */ GlobalStyle; }
/* harmony export */ });
/* unused harmony exports CheckboxWrapper, CheckboxText */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79749);
/* harmony import */ var _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    body {\n        overflow-x: hidden !important;\n    }\n    scroll-behavior: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: ",
        ";\n    height: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    justify-content: center;\n    ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    flex-direction: row;\n    margin-top: 10px;\n    align-items: center;\n    margin-top: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    font-weight: 500;\n    font-size: 12px;\n    color: #434f5a;\n    margin-left: 10px;\n    margin-top: 2px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    transform: -webkit-translate(-50%, -50%);\n    transform: -moz-translate(-50%, -50%);\n    transform: -ms-translate(-50%, -50%);\n    color: darkred;\n    width: 100px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: ",
        ";\n    width: 65px;\n    position: absolute;\n    left: 50%;\n    margin-top: ",
        ";\n    transform: translate(-50%, -50%);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin: 10px 0;\n    font-size: 12px;\n    color: ",
        ";\n    text-align: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var GlobalStyle = (0,_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.createGlobalStyle)(_templateObject());
var Flex = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject1());
var Img = (0,_acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled)((next_image__WEBPACK_IMPORTED_MODULE_2___default()))(_templateObject2(), function(props) {
    return props.width;
}, function(props) {
    return props.height;
});
var CenterDiv = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject3(), function(props) {
    return props && props.styles;
});
var CheckboxWrapper = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject4());
var CheckboxText = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject5());
var PageLoader = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.img(_templateObject6());
var ButtonLoaderImage = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.img(_templateObject7(), function(props) {
    return props.visibility ? "block" : "none";
}, function(props) {
    return props.marginTop || "30px";
});
var ErrorMessage = _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.styled.div(_templateObject8(), _acko_tech_building_blocks_ui_common__WEBPACK_IMPORTED_MODULE_1__.$error);


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(11720);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7210,2888,179], function() { return __webpack_exec__(88758); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);